import React from 'react'
import Link from 'gatsby-link'
import StoreLinks from "../components/storeLinks";
import IntroParagraph from "../components/IntroParagraph";

import appTour from "../img/app-tour.png"
import Formats from "../components/Formats";
import FormatsTS from "../components/FormatsTS";

const IndexPage = () => (
  <div>
    <h1>Welcome</h1>
    <IntroParagraph />

    <h1>The Series</h1>

    <h2 className="elm">TypeScript Accelerated</h2>

    <p></p>

    <FormatsTS />

    <h2 className="elm">Elm Accelerated</h2>

    <p>Elm is an extraordinary language and ecosystem for building complex front end web applications. While Elm takes
    ideas from the academic world of functional programming, it applies them in a pragmatic way to allow you to
      create web apps which not only never crash but are also amazingly maintainable. Out of the box you get an amazing
      compiler (which is more like a hyper intelligent pair programmer), a React-like
      virtual DOM, a Redux-like way of modeling state (but with so much less boilerplate and much more help from tooling).
    </p>

    <p>
      While Elm is incredibly solid and ready for production use (I've used it on two substantial, shipped projects) it
      is a bit lacking in learning resources. Elm Accelerated is a set of resources including an App, Book and more. The App, via flash cards,
      tracks your fluency on various topics and offers quick access to explanations for anything you are struggling with.
    </p>

    <Formats />

  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js